var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutritionNavIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.147 21.7651L12 21.7351L11.853 21.7651C9.476 22.2401 7.233 21.9751 5.593 20.6651C3.964 19.3601 2.75 16.8731 2.75 12.5001C2.75 8.02709 3.758 6.21009 5.085 5.54609C5.78 5.19909 6.678 5.09809 7.82 5.22909C8.961 5.36109 10.278 5.71709 11.763 6.21209L12.023 6.29809L12.278 6.19609C14.76 5.20409 16.991 4.82309 18.558 5.55509C20.028 6.24009 21.25 8.09309 21.25 12.5001C21.25 16.8741 20.037 19.3601 18.407 20.6641C16.767 21.9761 14.524 22.2411 12.147 21.7651Z",
    stroke: "#97A5A9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 3.5 11 2.5 9 2.5",
    stroke: "#97A5A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5V21.5",
    stroke: "#97A5A9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5V14.5",
    stroke: "#97A5A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionNavIcon);
export default __webpack_public_path__ + "static/media/Nutrition_Nav_Icon.0477d9568e1b01eee29dfa9d275816a6.svg";
export { ForwardRef as ReactComponent };